// extracted by mini-css-extract-plugin
export default {"chatPageChat1":"Chat1_chatPageChat1__5KJjD"};